var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagazine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M428.13,69.696V17.718H0V446.37c0,26.419,21.493,47.912,47.912,47.912h416.176c26.419,0,47.912-21.493,47.912-47.912 V69.696H428.13z M47.912,463.865c-9.647,0.001-17.495-7.847-17.495-17.494V48.135h367.295v36.768v15.209V446.37 c0,6.174,1.186,12.072,3.322,17.495H47.912z M481.583,446.371c0,9.647-7.848,17.495-17.495,17.495h-18.463 c-9.647,0-17.495-7.848-17.495-17.495V100.113h53.453V446.371z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.628,63.347V245.86h170.91V63.347H45.628z M186.121,215.443H76.045V93.764h110.076V215.443z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.628,266.142v182.512h116.887V266.142H45.628z M132.098,418.238H76.045V296.559h56.053V418.238z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.749,
    y: 63.35,
    width: 150.758,
    height: 30.417
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.749,
    y: 114.045,
    width: 150.758,
    height: 30.417
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.749,
    y: 164.741,
    width: 150.758,
    height: 30.417
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.749,
    y: 215.446,
    width: 150.758,
    height: 30.417
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.728,
    y: 266.142,
    width: 92.245,
    height: 30.417
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.251,
    y: 266.142,
    width: 92.245,
    height: 30.417
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.728,
    y: 316.837,
    width: 92.245,
    height: 30.417
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.728,
    y: 367.543,
    width: 92.245,
    height: 30.417
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.728,
    y: 418.238,
    width: 92.245,
    height: 30.417
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.251,
    y: 316.837,
    width: 92.245,
    height: 30.417
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.251,
    y: 367.543,
    width: 92.245,
    height: 30.417
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 290.251,
    y: 418.238,
    width: 92.245,
    height: 30.417
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazine);
export default __webpack_public_path__ + "static/media/Magazine.7d2b22e802635a85635c7b1bc7fea16c.svg";
export { ForwardRef as ReactComponent };